module.exports = __webpack_public_path__ + "static/img/df_userimg.dbdcdc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/df_userimg.png
// module id = jTQd
// module chunks = 1